/** One low-frequency lease for active visible canonical cards. Independent canvas
 * companions own their own frame leases. Visibility/input transitions call sync;
 * a settled, paused or hidden collection keeps no polling interval alive. */
export function createGameCollectionClock(players) {
  let timer = 0;
  function dispose() {
    clearInterval(timer);
    timer = 0;
  }
  function sync() {
    const needed = !document.hidden && [...players].some((player) => player.needsClock?.());
    if (!needed) dispose();
    else if (!timer)
      timer = setInterval(() => {
        for (const player of [...players]) if (player.needsClock?.()) player.tick();
        sync();
      }, 250);
  }
  return { sync, dispose };
}
